import { Device } from "@fairfleet/geotab";
import getDeviceLicensePlate from "@/hooks/getDeviceLicensePlate";
import { DeviceWithVehicleInfo } from "@/models/DeviceWithVehicleInfo";
import { normalizeSearchText } from "@/utilities/text/normalizeSearchText";

/**
 * The devices matching `search`, judged on name, license plate, serial number and VIN. Every
 * word of the search has to match one of them. An empty search keeps all devices.
 *
 * Done on the loaded fleet instead of asking Geotab again, so typing in the search box does not
 * trigger a new device request and a new twelve-month file request per search term.
 */
export function filterDevicesBySearch(devices: Device[], search: string): Device[] {
  const words = normalizeSearchText(search).split(/\s+/).filter(Boolean);
  if (words.length === 0) return devices;

  return devices.filter(device => {
    const haystack = normalizeSearchText(
      [
        device.name,
        getDeviceLicensePlate(device),
        device.serialNumber,
        // Only Vehicle declares the VIN, but the Device read here carries it (see the field list).
        (device as DeviceWithVehicleInfo).vehicleIdentificationNumber,
      ].join(" "),
    );
    return words.every(word => haystack.includes(word));
  });
}
